import {
    takeLatest, all, put, call,
} from 'redux-saga/effects';
import API from '../common/API';
import { waitAuthorizedCheck } from './Auth';
import * as Actions from '../actions/RegisterSeminarManagerment';

function* getListRegistSeminarManagement(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/event/${action.payload.event_name}/seminar/transaction/`;
        const response = yield call(
            API.get, {
                endpoint: `${endpoint}`,
                token: credential.data.token,
                body: {
                    page: action.payload.page,
                },
            },
        );
        yield put(Actions.GetListRegistSeminarRequestedReceived(response));
    } catch (error) {
        yield put(Actions.GetListRegistSeminarRequestedReceivedFailure(yield error));
    }
}
function* updateStatusRegistSeminar(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/event/${action.payload.event_name}/seminar/transaction/${action.payload.transaction_id}/status/`;
        const response = yield call(
            API.put, {
                endpoint,
                body: { status: action.payload.status },
                token: credential.data.token,
            },
        );
        yield put(Actions.UpdateStatusRegistSeminarRequestedReceived(response));
    } catch (error) {
        yield put(Actions.UpdateStatusRegistSeminarRequestedReceivedFailure(yield error));
    }
}

function* getDetailOrderSeminar(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/event/${action.payload.event_name}/seminar/order_content/${action.payload.transaction_id}/`;
        const response = yield call(API.get, {
            endpoint,
            body: {},
            token: credential.data.token,
        });
        yield put(Actions.getDetailOrderSeminarRequestedReceived(response));
    } catch (error) {
        yield put(Actions.getDetailOrderSeminarRequestedReceivedFailure(yield error));
    }
}

function* resentMailOrder(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/event/${action.payload.event_name}/seminar/transaction/${action.payload.transaction_id}/sent_invoice_issue/`;
        const response = yield call(API.get, {
            endpoint,
            body: {},
            token: credential.data.token,
        });
        yield put(Actions.resentMailSeminarRequestedReceived(response));
    } catch (error) {
        yield put(Actions.resentMailSeminarRequestedReceivedFailure(yield error));
    }
}

export default function* registerSeminarManagerment() {
    yield all([
        takeLatest('GET_LIST_REGIST_SEMINAR_REQUESTED', getListRegistSeminarManagement),
        takeLatest('GET_DETAIL_ORDER_SEMINAR_REQUESTED', getDetailOrderSeminar),
        takeLatest('UPDATE_STATUS_REGIST_SEMINAR_REQUESTED', updateStatusRegistSeminar),
        takeLatest('RESENT_MAIL_SEMINAR_REQUESTED', resentMailOrder),
    ]);
}
